<template>
  <KubmaNavbar />
  <slot />
  <KubmaFooter />
</template>

<script setup>
import KubmaNavbar from "~/components/home/Kubma/Navbar.vue";
import KubmaFooter from "~/components/home/Kubma/Footer.vue";

// const Navbar = defineAsyncComponent(() => import("~/components/Navbar.vue"));
// const Footer = defineAsyncComponent(() => import("~/components/Footer.vue"));
useHead({
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Kubma",
        url: "https://www.travvir.com",
        logo: "https://www.travvir.com/logo.png",
        foundingDate: "2021",
        founders: [
          {
            "@type": "Person",
            name: "Rohan mittal",
          },
        ],
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer support", //change according to need in production
          telephone: "*********", //add our actual phone number in production
          email: "rohan@travvir.com",
        },
        sameAs: [
          "https://www.instagram.com/travvir", //add our actual insta link in production
          "https://www.instagram.com/travvir", //add our actual facebook link in production
          "https://www.linkedin.com/company/travvir/",
          "https://x.com/Travvir_AI",
        ],
      }),
    },
  ],
});
</script>

<style lang="scss" scoped></style>
